import React, { type ComponentPropsWithoutRef } from 'react';
import { ReportErrors } from '@jira/platform__error-reporting/src/ReportErrors.tsx';
import Diagram from './AccessibleDiagram.tsx';

const WrappedDiagram = (props: ComponentPropsWithoutRef<typeof Diagram>): React.JSX.Element => (
	<ReportErrors
		id="unhandled"
		packageName="jiraAccessibleWorkflowDiagram"
		teamName="helix"
		sendToPrivacyUnsafeSplunk
	>
		<Diagram {...props} />
	</ReportErrors>
);

export default WrappedDiagram;
